import React from 'react';
import classes from './ShareIconButton.scss';

interface IShareIconButton {
  className?: string;
  clicked?: () => void;
}

const ShareIconButton: React.FC<IShareIconButton> = ({ className, clicked }) => (
  <div
    className={`${classes.shareIconButton}  ${className || ''}`}
    role="button"
    tabIndex={0}
    onClick={(event) => {
      event.stopPropagation();
      clicked?.();
    }}
    onKeyDown={() => {}}
  >
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66699 8V13.3333C2.66699 13.687 2.80747 14.0261 3.05752 14.2761C3.30756 14.5262 3.6467 14.6667 4.00033 14.6667H12.0003C12.3539 14.6667 12.6931 14.5262 12.9431 14.2761C13.1932 14.0261 13.3337 13.687 13.3337 13.3333V8"
        stroke="#0B1215"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.6663 4.00065L7.99967 1.33398L5.33301 4.00065" stroke="#0B1215" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 1.33398V10.0007" stroke="#0B1215" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

export default ShareIconButton;
